export default {
  sort: null,
  category: null,
  location: null,
  search: null,
  keywordMatchedCategory: false,
  radius: null,
  subcategory: null,
  reverseTextForLocals: ['ps', 'fa'],
  dynamic: {},
};



// WEBPACK FOOTER //
// ./src/store/filters/filters.state.js